import { useEffect } from "react";
import useSound from "use-sound";

import notificationSound from "@/assets/sounds/notification01.wav";
import { useVidyoStore } from "@/features/vidyo-call/utils/vidyo-store";

/**
 * This hook is used to play a notification sound when a new message is received.
 * But only if the chat drawer is not open and no notification has been played yet.
 */
export function useChatNotification() {
  const [play] = useSound(notificationSound, { volume: 0.3 });

  const hasNotificationPlayed = useVidyoStore(
    (s) => s.chat.hasNotificationPlayed,
  );
  const setHasNotificationPlayed = useVidyoStore(
    (s) => s.chat.setHasNotificationPlayed,
  );
  const chatDrawerOpen = useVidyoStore((s) => s.chatDrawer.isOpen);

  const messagesLength = useVidyoStore((s) => s.chat.messages.length);

  useEffect(() => {
    if (messagesLength > 0 && !hasNotificationPlayed && !chatDrawerOpen) {
      play();
      setHasNotificationPlayed(true);
    }
  }, [
    messagesLength,
    hasNotificationPlayed,
    setHasNotificationPlayed,
    chatDrawerOpen,
    play,
  ]);
}
